<template>
  <AccountSubscriptionForm
    :default-data="accountSubscription"
    :agency-options="agencyOptions"
    :billing-period-options="billingPeriodOptions"
    :membership-product-options="membershipProductOptions"
    :server-errors="serverErrors"
    :disabled="isLoading"
    @account-subscription-form:submit="doUpdate"
    @account-subscription-form:cancel="doCancel"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import AccountSubscriptionFormVue from './AccountSubscriptionForm.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  name: 'EditAccountAccountSubscriptionForm',

  components: {
    AccountSubscriptionForm: AccountSubscriptionFormVue,
  },

  props: {
    accountSubscription: {
      type: Object,
      required: true,
    },
    agencyOptions: {
      type: Array,
      default: () => [],
    },
    billingPeriodOptions: {
      type: Array,
      default: () => [],
    },
    membershipProductOptions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      status: STATUS_IDLE,
      serverErrors: {},
      errorMessage: '',
    };
  },

  computed: {
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  methods: {
    ...mapActions('ui/accountSubscriptions', {
      updateAccountSubscription: 'update',
    }),

    async doUpdate(formData) {
      if (this.isLoading) return;

      const { uuid: accountSubscriptionUuid } = this.accountSubscription;

      this.errorMessage = '';
      this.status = STATUS_PENDING;

      try {
        await this.updateAccountSubscription({ accountSubscriptionUuid, formData });

        this.status = STATUS_RESOLVED;

        this.$emit('edit-account-subscription-form:updated', accountSubscriptionUuid);
      } catch (error) {
        this.status = STATUS_REJECTED;

        if (!error.response) {
          this.errorMessage = 'Something went wrong. Try again later';
        }

        if (error.response.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.data.errors = error.response.data.errors;
          this.data.errorMessage = error.response.data.message;
        }
      }
    },

    doCancel() {
      if (this.isLoading) return;

      this.$emit('edit-account-subscription-form:cancel');
    },
  },
};
</script>
